export default "__VITE_ASSET__SnBbTEt2__"